import { cva } from "class-variance-authority"

// SCSS-based form variants using WeLoop design system classes
export const formVariants = cva(
  "wl-form", // Base WeLoop form class
  {
    variants: {
      layout: {
        default: "", // Default layout
        horizontal: "wl-form-horizontal",
        vertical: "wl-form-vertical",
        inline: "wl-form-inline",
      },
      spacing: {
        default: "", // Default spacing
        compact: "wl-form-compact",
        relaxed: "wl-form-relaxed",
      },
    },
    defaultVariants: {
      layout: "default",
      spacing: "default",
    },
  }
)

export const formItemVariants = cva(
  "wl-form-item", // Base WeLoop form item class
  {
    variants: {
      layout: {
        default: "", // Default layout
        horizontal: "wl-form-item-horizontal",
        vertical: "wl-form-item-vertical",
      },
      size: {
        default: "", // Default size
        sm: "wl-form-item-sm",
        lg: "wl-form-item-lg",
      },
    },
    defaultVariants: {
      layout: "default",
      size: "default",
    },
  }
)

export const formLabelVariants = cva(
  "wl-form-label", // Base WeLoop form label class
  {
    variants: {
      size: {
        default: "", // Default size
        sm: "wl-form-label-sm",
        lg: "wl-form-label-lg",
      },
      weight: {
        default: "", // Default weight
        normal: "wl-form-label-normal",
        medium: "wl-form-label-medium",
        semibold: "wl-form-label-semibold",
        bold: "wl-form-label-bold",
      },
    },
    defaultVariants: {
      size: "default",
      weight: "default",
    },
  }
)

export const formMessageVariants = cva(
  "wl-form-message", // Base WeLoop form message class
  {
    variants: {
      type: {
        default: "", // Default type
        error: "wl-form-message-error",
        warning: "wl-form-message-warning",
        success: "wl-form-message-success",
        info: "wl-form-message-info",
      },
      size: {
        default: "", // Default size
        sm: "wl-form-message-sm",
        lg: "wl-form-message-lg",
      },
    },
    defaultVariants: {
      type: "default",
      size: "default",
    },
  }
)

export const formDescriptionVariants = cva(
  "wl-form-description", // Base WeLoop form description class
  {
    variants: {
      size: {
        default: "", // Default size
        sm: "wl-form-description-sm",
        lg: "wl-form-description-lg",
      },
      color: {
        default: "", // Default color
        muted: "wl-form-description-muted",
        secondary: "wl-form-description-secondary",
      },
    },
    defaultVariants: {
      size: "default",
      color: "default",
    },
  }
) 